module.exports = __webpack_public_path__ + "static/social-card-55d19ee09b31aef123db018cdaa85dac.jpg";